export const formatNotificationDate = (timestamp) => {
  if (!timestamp) return "";

  let date;
  if (Array.isArray(timestamp)) {
    const [y, m, d, h, min, s] = timestamp;
    date = new Date(y, m - 1, d, h, min, s || 0);
  } else {
    date = new Date(timestamp);
  }

  const diff = Math.max(0, Date.now() - date.getTime());
  const sec = Math.floor(diff / 1000);
  const min = Math.floor(diff / (1000 * 60));
  const hr = Math.floor(diff / (1000 * 60 * 60));
  const day = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (sec < 60) return `${sec} sec ago`;
  if (min < 60) return `${min} min ago`;
  if (hr < 24) return `${hr} hr ago`;
  if (day < 7) return `${day} days ago`;

  return date.toLocaleDateString("en-US", { day: "numeric", month: "short" });
};

export const groupNotificationsByType = (notifications) =>
  notifications.reduce((acc, n) => {
    if (!acc[n.type]) acc[n.type] = [];
    acc[n.type].push(n);
    return acc;
  }, {});
